import { __assign } from "tslib";
import React, { useState } from 'react';
import { Button, ErrorBoundary, Input } from '../UI';
import validate from '../../utilities/validation';
import Consents from '../Consents';
import { Loader } from '../UI/Loader';
/**
 * Renders form component with email and password
 *
 * @param  {string} [className] - the CSS classes
 * @param  {(email: string, password: string) => void} [onClick] - onClick handler launching after submit form
 * @param  {string} [submitLabel] - submit button text
 * @param  {string} [inputStyles] - input CSS classes
 * @param  {string} [buttonStyles] - btn CSS classes
 * @param  {string} [labelStyles] - label CSS classes
 * @param  {string} [formStyles] - form CSS classes
 * @param  {string} [formGroupStyles] - form group CSS classes
 *
 * @example
 * <EmailPasswordForm
 *  className='a6y-react-auth-form'
 *  onClick={onClick}
 *  submitLabel='Submit'
 *  inputStyles='',
 *  buttonStyles='',
 * />
 */
function EmailPasswordForm(_a) {
    var _b, _c, _d;
    var _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
    var _u = _a.className, className = _u === void 0 ? 'a6y-react-auth__form' : _u, onClick = _a.onClick, _v = _a.submitLabel, submitLabel = _v === void 0 ? 'Submit' : _v, _w = _a.signUp, signUp = _w === void 0 ? false : _w, _x = _a.loader, loader = _x === void 0 ? false : _x, _y = _a.inputStyles, inputStyles = _y === void 0 ? '' : _y, _z = _a.buttonStyles, buttonStyles = _z === void 0 ? '' : _z, _0 = _a.labelStyles, labelStyles = _0 === void 0 ? '' : _0, _1 = _a.formStyles, formStyles = _1 === void 0 ? '' : _1, _2 = _a.formGroupStyles, formGroupStyles = _2 === void 0 ? '' : _2, path = _a.path, _3 = _a.consentsHrefStyle, consentsHrefStyle = _3 === void 0 ? '' : _3, _4 = _a.consentInputLabelStyle, consentInputLabelStyle = _4 === void 0 ? '' : _4, _5 = _a.consentInputStyle, consentInputStyle = _5 === void 0 ? '' : _5, _6 = _a.consentTextStyle, consentTextStyle = _6 === void 0 ? '' : _6, _7 = _a.consentSpanStyle, consentSpanStyle = _7 === void 0 ? '' : _7, _8 = _a.consentsStyle, consentsStyle = _8 === void 0 ? '' : _8, _9 = _a.consentsLabelStyle, consentsLabelStyle = _9 === void 0 ? '' : _9;
    var _10 = useState(false), conditions = _10[0], setConditions = _10[1];
    var _11 = useState([]), consents = _11[0], setConsents = _11[1];
    var _12 = useState(false), conditionsError = _12[0], setConditionsError = _12[1];
    var _13 = useState({
        email: '',
        password: '',
        confirmPassword: '',
    }), signUpData = _13[0], setSignUpData = _13[1];
    var _14 = useState({
        email: false,
        password: false,
        confirmPassword: false,
    }), errorData = _14[0], setErrorData = _14[1];
    var classNames = require('classnames');
    var FormClassEmail = classNames((_b = {},
        _b[className + "--error"] = errorData.email ? true : false,
        _b));
    var FormClassPassword = classNames((_c = {},
        _c[className + "--error"] = errorData.password ? true : false,
        _c));
    var FormClassRepeatPassword = classNames((_d = {},
        _d[className + "--error"] = errorData.confirmPassword ? true : false,
        _d));
    var onInputChange = function (e, target) {
        var _a, _b;
        setErrorData(__assign(__assign({}, errorData), (_a = {}, _a[target] = e.target.value.length === 0, _a)));
        setSignUpData(__assign(__assign({}, signUpData), (_b = {}, _b[target] = e.target.value, _b)));
    };
    function setConditionsValues(val, consentsVal) {
        var _a, _b, _c, _d;
        var newConsents = [];
        if ((_b = (_a = globalThis.A6YReactAuthConfig.components) === null || _a === void 0 ? void 0 : _a.consents) === null || _b === void 0 ? void 0 : _b.consents) {
            (_d = (_c = globalThis.A6YReactAuthConfig.components) === null || _c === void 0 ? void 0 : _c.consents) === null || _d === void 0 ? void 0 : _d.consents.map(function (el, idx) {
                if (consentsVal[idx]) {
                    newConsents.push(__assign(__assign({}, el), { value: consentsVal[idx] }));
                }
                else {
                    newConsents.push(__assign(__assign({}, el), { value: el.type !== 'checkbox' ? true : false }));
                }
            });
        }
        setConsents(newConsents);
        setConditions(val);
    }
    var onSubmit = function (e) {
        setErrorData({
            email: false,
            password: false,
            confirmPassword: false,
        });
        e.stopPropagation();
        e.preventDefault();
        var data = [
            {
                value: signUpData.email,
                rules: ['CANNOT_BE_BLANK'],
            },
            {
                value: signUpData.password,
                rules: ['CANNOT_BE_BLANK'],
            },
        ];
        if (onClick && validate(data)) {
            if (signUp) {
                if (signUpData.password === signUpData.confirmPassword) {
                    setConditionsError(!conditions);
                    if (onClick && conditions) {
                        onClick(signUpData.email, signUpData.password, consents);
                    }
                }
                else {
                    setErrorData(__assign(__assign({}, errorData), { password: true, confirmPassword: true }));
                }
            }
            else {
                setConditionsError(!conditions);
                if (onClick) {
                    onClick(signUpData.email, signUpData.password);
                }
            }
        }
        else {
            if (!errorData.email && !errorData.password)
                setErrorData(__assign(__assign({}, errorData), { email: true, password: true }));
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(ErrorBoundary, { showError: signUp && conditionsError ? true : false }, "All required consents must be accepted."),
        React.createElement("form", { className: formStyles && formStyles.length > 0 ? formStyles : "" + className, onSubmit: function (e) { return onSubmit(e); } },
            React.createElement("div", { className: formGroupStyles && formGroupStyles.length > 0
                    ? formGroupStyles + " "
                    : className + "-group " + FormClassEmail },
                React.createElement(Input, { id: 'email', placeholder: 'Email', typeInput: 'email', label: 'email', onChange: function (e) { return onInputChange(e, 'email'); }, value: signUpData.email, inputStyles: inputStyles, labelStyles: labelStyles })),
            React.createElement("div", { className: formGroupStyles && formGroupStyles.length > 0
                    ? formGroupStyles + " " + FormClassPassword
                    : className + "-group " + FormClassPassword },
                React.createElement(Input, { id: 'password', typeInput: 'password', placeholder: 'Password', label: 'password', onChange: function (e) { return onInputChange(e, 'password'); }, value: signUpData.password, inputStyles: inputStyles, labelStyles: labelStyles })),
            signUp &&
                ((_f = (_e = globalThis.A6YReactAuthConfig.components) === null || _e === void 0 ? void 0 : _e.signUp) === null || _f === void 0 ? void 0 : _f.confirmation) && (React.createElement("div", { className: formGroupStyles && formGroupStyles.length > 0
                    ? formGroupStyles + " "
                    : className + "-group " + FormClassRepeatPassword },
                React.createElement(Input, { id: 'confirm-password', typeInput: 'password', placeholder: 'Confirm password', inputStyles: inputStyles, labelStyles: labelStyles, label: 'confirm password', onChange: function (e) { return onInputChange(e, 'confirmPassword'); }, value: signUpData.confirmPassword }))),
            globalThis.A6YReactAuthConfig &&
                (((_h = (_g = globalThis.A6YReactAuthConfig.components) === null || _g === void 0 ? void 0 : _g.consents) === null || _h === void 0 ? void 0 : _h.display) ===
                    'both' ||
                    ((_k = (_j = globalThis.A6YReactAuthConfig.components) === null || _j === void 0 ? void 0 : _j.consents) === null || _k === void 0 ? void 0 : _k.display) ===
                        path) &&
                ((_m = (_l = globalThis.A6YReactAuthConfig.components) === null || _l === void 0 ? void 0 : _l.consents) === null || _m === void 0 ? void 0 : _m.position) ===
                    'top' && (React.createElement(Consents, { consentsHrefStyle: consentsHrefStyle, consentInputLabelStyle: consentInputLabelStyle, consentInputStyle: consentInputStyle, consentTextStyle: consentTextStyle, consentSpanStyle: consentSpanStyle, consentsLabelStyle: consentsLabelStyle, className: consentsStyle, isValid: function (value, consents) {
                    return setConditionsValues(value, consents);
                } })),
            React.createElement(Button, { className: buttonStyles, role: 'submit', style: 'primary', disabled: loader }, loader ? React.createElement(Loader, null) : submitLabel),
            globalThis.A6YReactAuthConfig &&
                (((_p = (_o = globalThis.A6YReactAuthConfig.components) === null || _o === void 0 ? void 0 : _o.consents) === null || _p === void 0 ? void 0 : _p.display) ===
                    'both' ||
                    ((_r = (_q = globalThis.A6YReactAuthConfig.components) === null || _q === void 0 ? void 0 : _q.consents) === null || _r === void 0 ? void 0 : _r.display) ===
                        path) &&
                ((_t = (_s = globalThis.A6YReactAuthConfig.components) === null || _s === void 0 ? void 0 : _s.consents) === null || _t === void 0 ? void 0 : _t.position) ===
                    'bottom' && (React.createElement(Consents, { consentsHrefStyle: consentsHrefStyle, consentInputLabelStyle: consentInputLabelStyle, consentInputStyle: consentInputStyle, consentTextStyle: consentTextStyle, consentSpanStyle: consentSpanStyle, className: consentsStyle, isValid: function (value, consents) {
                    return setConditionsValues(value, consents);
                } })))));
}
export default EmailPasswordForm;
//# sourceMappingURL=EmailPasswordForm.js.map